export const enumPermisosFdlm = Object.freeze({
  RECAUDO_FUNDACION_DE_LA_MUJER: 17,
  REVERSO_RECAUDO_FUNDACION_DE_LA_MUJER: 27,
});
